// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3IlwT","inner":"Footer_inner__2gEIz","nextIcon":"Footer_nextIcon__3qa4h","innerLeft":"Footer_innerLeft__1DHEJ"};